// Import any other modules or utilities you need
// import { someUtility } from './utilities';
import Auth from './auth';
import Streaks from './streaks';
import Stats from './stats';
import ABTesting from './ab-testing';
import Blog from './blog';
import DevToolbar, { DevToolbarAPI } from './dev-toolbar';
import * as Partners from './partners';

import {
  handleAuthAndSetupUI,
  HandleAuthAndSetupUIProps,
  toggleSidebar,
} from './dom-manipulation';

import { updateNavbarForLevel } from '../utils/updateStreakDisplay';

interface HeyGGConfig {
  apiBaseUrl: string;
  googleClientId?: string;
  enablePartners?: boolean;
}

const defaultConfig: HeyGGConfig = {
  apiBaseUrl: 'https://play.hey.gg',
};

const config = { ...defaultConfig };

const setConfig = (newConfig: Partial<HeyGGConfig>) => {
  window.HeyGoodGame.config = { ...window.HeyGoodGame.config, ...newConfig };
};

const HeyGoodGame: {
  Auth: typeof Auth;
  Blog: typeof Blog;
  Streaks: typeof Streaks;
  Stats: typeof Stats;
  ABTesting: typeof ABTesting;
  DevToolbar: DevToolbarAPI;
  Partners: typeof Partners;
  config: HeyGGConfig;
  setConfig: (newConfig: Partial<HeyGGConfig>) => void;
  toggleSidebar: () => void;
  handleAuthAndSetupUI: (props: HandleAuthAndSetupUIProps) => Promise<void>;
  updateNavbarForLevel: (gameKey: string, level: string) => Promise<void>;
} = {
  Auth,
  Blog,
  Streaks,
  Stats,
  ABTesting,
  DevToolbar,
  Partners,
  config,
  setConfig,
  toggleSidebar,
  handleAuthAndSetupUI,
  updateNavbarForLevel,
};

// Export everything you want to make available globally
export {
  HeyGoodGame,
  Auth,
  Blog,
  Streaks,
  Stats,
  ABTesting,
  DevToolbar,
  Partners,
  config,
  setConfig,
  toggleSidebar,
  handleAuthAndSetupUI,
  updateNavbarForLevel,
};

declare global {
  interface Window {
    HeyGoodGame: {
      Auth: typeof Auth;
      Blog: typeof Blog;
      Streaks: typeof Streaks;
      Stats: typeof Stats;
      ABTesting: typeof ABTesting;
      DevToolbar: DevToolbarAPI;
      Partners: typeof Partners;
      config: HeyGGConfig;
      setConfig: (newConfig: Partial<HeyGGConfig>) => void;
      toggleSidebar: () => void;
      handleAuthAndSetupUI: (props: HandleAuthAndSetupUIProps) => Promise<void>;
      updateNavbarForLevel: (gameKey: string, level: string) => Promise<void>;
    };
  }
}

window.HeyGoodGame = HeyGoodGame;
